<template></template>
<script>
import { Toast } from "we-vue";
export default {
  name: "getroleandlogin",
  data() {
    return {
      disid: "",
      code: "", //获取授权后回调code
      loginType: -1,
      jumpurl: "" //跳转地址
    };
  },
  created: function() {
    var url = window.location.href;
    var i = url.indexOf("jumpurl=");
    if (i > 0) {
      this.jumpurl = url.substring(i + 8);
    }
    var jumpurl = decodeURIComponent(this.jumpurl);
    var disid = this.GetRequest(jumpurl)["disid"];
    if (disid == undefined || disid == null || disid == "") {
      var i = jumpurl.indexOf("disid=");
      if (i != -1 && jumpurl.length >= i + 25) {
        disid = jumpurl.substring(i + 6, i + 26);
      }
    }
    if (disid != undefined && disid != null && disid.length > 0) {
      this.disid = disid;
    }
    this.code = this.GetRequest(url)["code"];
    if (this.code != undefined && this.code != null && this.code.length > 0) {
      this.GetRole(this.code, this.disid);
    }
  },
  methods: {
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
          var jumpurl = decodeURIComponent(this.jumpurl);
          if (jumpurl != "undefined" && jumpurl != "") {
            window.location.href = this.GLOBAL.WEB_URL + "#" + jumpurl;
          } else {
            window.location.href = this.GLOBAL.WEB_URL + "#/app/home";
          }
        } else {
          Toast.fail(rep.Message);
        }
      });
    },

    //获取用户角色
    GetRole: function(code, disid) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getrole", {
          params: {
            code: code,
            disid: disid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.loginType = rep.Data.LoginType;
            if (rep.Data.Token.length > 0) {
              localStorage.setItem("token", JSON.stringify(rep.Data.Token));
              localStorage.setItem("loginType", this.loginType);
              localStorage.setItem("showFun", false);
              this.setcache();
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/login/getroleandlogin.vue